import React, { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { AuthContext } from "../../context/AuthContext";

// Layout for /advisor/*. Navigation is handled entirely by the primary
// <Navbar/>, which switches into "advisor mode" on /advisor/* and shows
// Dashboard / Profile / Skills / Plans as the primary tabs (plus an
// "ADVISOR" badge + a "Back to investor view" affordance in the avatar
// dropdown). No sub-tab bar here — having two parallel nav rows was
// confusing.

const AdvisorShell = () => {
  const { profile, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!profile) return;
    if (!profile.is_advisor) {
      navigate("/settings?tab=billing", { replace: true });
    }
  }, [loading, profile, navigate]);

  if (loading || !profile) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-b dark:from-gray-900 dark:via-gray-950 dark:to-black">
        <Navbar />
      </div>
    );
  }

  if (!profile.is_advisor) return null;

  return (
    <div
      className="
        min-h-screen pt-28
        bg-gray-50 text-gray-900
        dark:bg-gradient-to-b dark:from-gray-900 dark:via-gray-950 dark:to-black
        dark:text-white
      "
    >
      <Navbar />
      <div className="max-w-[1100px] mx-auto px-6 pt-4 pb-12 animate-fadeIn">
        <Outlet />
      </div>
    </div>
  );
};

export default AdvisorShell;
